import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=5f0af536&scoped=true&"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=5f0af536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0af536",
  null
  
)

export default component.exports